/*    
<summary>
  This functional component is used for proper authentication of user using the StoreLogin Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { errorMessage } from "../../constants/error-constants";
import { useStore } from "../../contexts/store-provider";
import { getUserTypeFromLocalStorage } from "../../helpers/localstorage-helper";
import { IUserTypeLogin } from "../../models/forms/ILogin";
import Footer from "../../shared-components/footer/footer";
import RoutesConstants from "../../shared-components/routes/routes-constants";
import { formatMessage } from "../../translations/format-message";
import LoginForm from "./forms/login-form";
import "./login.css";

const StoreLogin = (props: any) => {
  const history = useHistory();
  const { authStore, preferencesStore } = useStore();

  const { error, inProgress }: any = authStore;
  const { isAuthenticated, getToken, login, loginAsStoreService } = authStore;
  const [storeCodeCookies, setStoreCodeCookie, removeStoreCodeCookie] = useCookies(["storeCode"]);
  const storeCodeFromCookies = storeCodeCookies.storeCode ?? "";
  const initialValues: IUserTypeLogin = {
    email: "",
    password: "",
    storeCode: storeCodeFromCookies,
    userType: 3,
    rememberMe: storeCodeFromCookies !== "" ? true : false,
  };

  /**
   * This function handles login functionlity for user
   */
  const handleLogin = (values: IUserTypeLogin) => {
    if (values.rememberMe == true) {
      setStoreCodeCookie("storeCode", values.storeCode);
    } else {
      removeStoreCodeCookie("storeCode");
    }
    loginAsStoreService(values);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "isAuthenticated" of the useEffect changed.
   */
  useEffect(() => {
    if (isAuthenticated || getToken) {
      // getVersion();
      let userType = getUserTypeFromLocalStorage();
      if(userType == userTypeEnum[3]) history.push(RoutesConstants.Dashboard);
      else history.push(RoutesConstants.StoreLogin);
    }
  }, [isAuthenticated]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      if (error === errorMessage.UserAlreadyLogin) {
        props.confirmLoginPopupToggleHandler();
      } else {
        toast.error(formatMessage(error));
        authStore.reset();
      }
    }
  }, [error]);

  return (
    <> 
      <LoginForm
        isLoading={inProgress}
        loginHandler={handleLogin}
        initialValues={initialValues}
      />
      <Footer />
    </>
  );
};

export default observer(StoreLogin);
